<template>
  <div>
    <router-view></router-view>
    <Loading v-if="this.$store.state.loading" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Loading from '@/components/Loading.vue';

export default defineComponent({
  components: { Loading },
});
</script>
